import { ApolloLink } from '@apollo/client'

import { trimValues } from '@/modules/shared/utils/trimValues'

export function createVariableTransformLink() {
  return new ApolloLink((operation, forward) => {
    const { variables } = operation

    const transformedVariables = trimValues(variables)

    // Apply any transformations here
    // transformedVariables = transformFunction(transformedVariables)
    operation.variables = transformedVariables

    return forward(operation)
  })
}
